import { HashLink } from "react-router-hash-link";
import useScrollToSection from '../components/scroll';

const Home = ({scrollTo}) => {

  useScrollToSection()
  return (
    <>
      <section id="landing">
        <div className="th-hero-wrapper hero-3" id="hero">
          <div className="swiper th-slider hero-slider-3" id="heroSlide3" data-slider-options='{"effect":"fade","loop":true,"autoplay":{"delay":4000,"disableOnInteraction":false},"pagination":{}}'>
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="hero-inner">
                  <div className="th-hero-bg" data-bg-src="assets/img/hero/hero_bg_3_1.jpg"><img
                      src="assets/img/hero/SHEQ Climbing.jpg" alt="Hero "/>
                    <div className="hero-shape-1" data-ani="slideinleft" data-ani-delay="0.7s"><img
                        src="assets/img/hero/hero_overlay_3_1.png" alt=""/></div>
                  </div>
                  <div className="container">
                    <div className="hero-style3">
                      <div className="hero-meta"><span data-ani="slideindown" data-ani-delay="0.1s"></span><span data-ani="slideindown"
                          data-ani-delay="0.2s">Excellence</span> <span data-ani="slideindown"
                          data-ani-delay="0.3s">Intergrity</span> <span data-ani="slideindown"
                          data-ani-delay="0.4s">Sustainability</span></div>
                      <h1 className="hero-title" data-ani="slideinleft" data-ani-delay="0.4s">At MRN, we make it our business to embed quality, safety, and sustainability into everything you do.
                        </h1>
                      <div className="btn-group" data-ani="slideinup" data-ani-delay="0.6s">
                         <HashLink smooth to="/#about" className="th-btn style1 th-style th-icon">
                          Discover More
                          <i className="fa-regular fa-arrow-right ms-2"></i>
                        </HashLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <button data-slider-prev="#heroSlide3" className="slider-arrow slider-prev"><i
              className="far fa-arrow-left"></i>
            </button> 
            <button data-slider-next="#heroSlide3"
              className="slider-arrow slider-next"><i className="far fa-arrow-right"></i>
            </button> */}

            <div className="slider-pagination"></div>
            <div className="border-line"></div>
          </div>
        </div>
      </section>
      <section id="values" className="process-sec3 overflow-hidden space">
        <div className="container th-container">
          <div className="process-card-area">
            <div className="row gy-4 align-items-center">
              <div className="col-md-6 col-xl-3">
                <div className="title-area text-center text-md-start">
                  <h2 className="sec-title text-white mb-0" style={{ fontSize:"100px", marginTop: "180px" }}>Our</h2>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="process-card"><span className="process-card_subtitle">Step - 01</span>
                  <div className="process-card_icon"><img src="assets/img/icon/high-quality-svgrepo-com.svg" alt="icon"/></div>
                  <h4 className="box-title">Excellence</h4>
                  <p className="process-card_text">We strive for the highest standards in everything we do, ensuring quality, compliance, and customer satisfaction.</p>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="process-card"><span className="process-card_subtitle">Step - 02</span>
                  <div className="process-card_icon"><img src="assets/img/icon/checklist-and-pencil-svgrepo-com.svg" alt="icon"/></div>
                  <h4 className="box-title">Integrity</h4>
                  <p className="process-card_text">We operate with honesty, transparency, and accountability in all our relationships and engagements.</p>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="process-card"><span className="process-card_subtitle">Step - 03</span>
                  <div className="process-card_icon"><img src="assets/img/icon/idea-svgrepo-com.svg" alt="icon"/></div>
                    <h4 className="box-title">Innovation</h4>
                    <p className="process-card_text">We embrace forward-thinking and continuously seek better ways to deliver value to our clients.</p>
                </div>
              </div>              
              <div className="col-md-6 col-sm-1 col-xl-3">
                <div className="title-area mb-0 text-center text-md-start">
                  <h2 className="sec-title text-white mb-0" style={{ fontSize:"100px", marginTop: "-250px" }}>Core Values</h2>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="process-card"><span className="process-card_subtitle">Step - 04</span>
                  <div className="process-card_icon"><img src="assets/img/icon/earth-network-svgrepo-com.svg" alt="icon"/></div>
                  <h4 className="box-title">Sustainability</h4>
                  <p className="process-card_text">We champion environmentally and socially responsible practices that positively impact communities and the planet.</p>
                </div>
              </div>
              <div className="col-md-6 col-xl-3"></div>
              <div className="col-md-6 col-xl-3">
                <div className="process-card"><span className="process-card_subtitle">Step - 05</span>
                  <div className="process-card_icon"><img src="assets/img/icon/glasses-helmet-svgrepo-com.svg" alt="icon"/></div>
                  <h4 className="box-title">Safety First</h4>
                  <p className="process-card_text">We prioritize the health and safety of people in every solution we provide, aligning with international best practices.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="about">
        <div className="container" style={{padding:"24px", textAlign:"center" }}>
          <div className="title-area mb-25"><span className="sub-title style3">About MRN Enterprise</span>
            <h2 className="sec-title mb-20">Excellence is not an act, but a habit</h2>
          </div>
          <p className="sec-text mb-30">MRN Enterprise is a proudly South African, woman-led consultancy offering integrated business solutions across ISO certification, corporate branding, safety compliance, and workforce development. Founded on a strong foundation of expertise in Safety, Health, Environment, and Quality (SHEQ), we are committed to empowering organisations to achieve operational excellence and regulatory compliance.</p>
          <p className="sec-text mb-30">We specialise in the implementation of ISO Management Systems (ISO 9001, 14001, 45001), development of Construction Health & Safety Files, Environmental and Risk Management Systems, as well as SHEQ training and awareness programmes.</p>
          <p className="sec-text mb-30">Our offering also includes sustainable corporate gifting, branded corporate wear, high-quality PPE supply, and Workplace Skills Plan (WSP) development and submission.</p>
          <p className="sec-text mb-30">Driven by service excellence, innovation, and integrity, we partner with businesses to improve performance, reduce risk, and foster safe, compliant, and purpose-driven workplaces.</p>
          <div className="about-item-wrap">
            <div className="about-item style2">
              <div className="about-item_centent">
                <h5 className="box-title"><span className="text-theme">Our</span> Vision</h5>
                <p className="about-item_text">To be the world’s Contractor and Employer of Choice by safely and consistently delivering successful and innovative capital projects and services across South Africa</p>
              </div>
            </div>
            <div className="about-item style2">
              <div className="about-item_centent">
                <h5 className="box-title"><span className="text-theme">Our</span> Mission</h5>
                <p className="about-item_text">To maintain the highest levels of professionalism, integrity, honesty and fairness in our relationships with our suppliers, subcontractors, professional associates and customers.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="marquee-section overflow-hidden">
          <div className="marquee-wrapper">
            <div className="marquee">
              <div className="marquee-group">
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Health & Safety</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Management Systems</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>SHEQ Training</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Risk Management</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Environmental Management Systems</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Awareness Programmes</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Quality Management Systems</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Workplace Skills Plans</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>ISO/TS</div>
              </div>
              <div aria-hidden="true" className="marquee-group">
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Health & Safety</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Management Systems</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>SHEQ Training</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Risk Management</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Environmental Management Systems</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Awareness Programmes</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Quality Management Systems</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>Workplace Skills Plans</div>
                <div className="text"><img src="assets/img/icon/marquee-icon.svg" alt=""/>ISO/TS</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="space" id="clients" style={{ paddingTop:"80px" }}>
        <div className="container">
          <div className="title-area text-center mb-40"><span className="sub-title">Latest Clients</span>
          <h2 className="sec-title">Some Of Our Biggest Clients</h2>
        </div>
          <div className="row gallery-row filter-active">
            <div className="col-md-6 col-xl-3 filter-item ">
              <div className="project-box">
                <div className="project-box-img"><img src="assets/img/clients/rjTech_logo.jpg" alt="RJ Tech"/></div>
                <div className="project-box-content">
                  <p className="project-subtitle">Rjt Tech</p>
                  <h3 className="box-title"><a href="project-details.html">Telecom & Tech</a></h3><a
                    href="https://www.rjttech.co.za/" className="gallery-btn popup-image"><i className="fa-regular fa-plus"/></a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-3 filter-item ">
              <div className="project-box">
                <div className="project-box-img"><img src="assets/img/clients/mrn_construction_logo.jpg" alt="MRN Construction"/></div>
                <div className="project-box-content">
                  <p className="project-subtitle">MRN Constructions</p>
                  <h3 className="box-title"><a href="project-details.html">Civil & Construction</a></h3><a
                    href="https://mrngroup.co.za/" target= "BLANK_" className="gallery-btn popup-image"><i className="fa-regular fa-plus"/></a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-3 filter-item ">
              <div className="project-box">
                <div className="project-box-img"><img src="assets/img/clients/mrn_investments.jpg" alt="MRN Investment"/></div>
                <div className="project-box-content">
                  <p className="project-subtitle">MRN Group</p>
                  <h3 className="box-title"><a href="project-details.html">Investment Group</a></h3><a
                    href="https://mrngroup.co.za/" target="BLANK_" className="gallery-btn popup-image"><i className="fa-regular fa-plus"/></a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-3 filter-item">
              <div className="project-box">
                <div className="project-box-img"><img src="assets/img/clients/Logo_Tendai.jpg" alt="Tendai ICT"/></div>
                <div className="project-box-content">
                  <p className="project-subtitle">Tendai ICT</p>
                  <h3 className="box-title"><a href="project-details.html">IT & Tellecommunications</a></h3><a
                    href="https://www.tendaiict.com/" target="BLANK_" className="gallery-btn popup-image"><i className="fa-regular fa-plus"/></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;